import script from "./listTableGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./listTableGeneral.vue?vue&type=script&setup=true&lang=js"

import "./listTableGeneral.vue?vue&type=style&index=0&id=24138dae&lang=css"

const __exports__ = script;

export default __exports__